const staleChunkReloadKey = 'apx:web-public:stale-chunk-reloaded-at';
// Long enough to stop a reload loop when a file is truly missing, short enough to recover from the next deploy.
const reloadCooldownMs = 30_000;

/** A deploy replaced the hashed files this open tab still refers to. */
export function isStaleChunkError(reason: unknown): boolean {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : String((reason as { message?: unknown })?.message ?? reason ?? '');

  return /importing a module script failed|loading dynamically imported module|failed to fetch dynamically imported module|ChunkLoadError|Loading chunk/i.test(
    message,
  );
}

/** Loads the latest build once, landing on `url` when given. Returns false if it already tried recently. */
export function reloadForStaleChunk(url?: string, now = Date.now()): boolean {
  try {
    const last = sessionStorage.getItem(staleChunkReloadKey);
    if (last !== null && now - Number(last) < reloadCooldownMs) {
      return false;
    }
    sessionStorage.setItem(staleChunkReloadKey, String(now));
  } catch {
    // Without storage there is no loop guard, so don't reload automatically.
    return false;
  }
  if (url) {
    window.location.assign(url);
  } else {
    window.location.reload();
  }
  return true;
}
